import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {rangeDate} from 'shared/tools';
import {Employee} from 'main/stores/employees';

class EmployeeTrainingStatusSummary extends DomainObject {
  id;
  employee;
  dueDate;
  completedAt;
  completed;
  programName;
  totalAnswerCount;
  correctAnswerCount;
  hasIncompleteTraining;

  _relations = {
    employee: Employee,
    _dates: ['dueDate', 'completedAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      employee: observable,
      dueDate: observable,
      completedAt: observable,
      completed: observable,
      programName: observable,
      totalAnswerCount: observable,
      correctAnswerCount: observable,
      hasIncompleteTraining: observable,
      dueDateView: computed,
      completedAtView: computed,
      quizScore: computed,
      quizResultsView: computed
    });

    this.merge(other);
  }

  get dueDateView() {
    return rangeDate(this.dueDate);
  }

  get completedAtView() {
    return rangeDate(this.completedAt);
  }

  get quizScore() {
    if (!this.totalAnswerCount) return '--';

    return Math.round(this.correctAnswerCount / this.totalAnswerCount * 100);
  }

  get quizResultsView() {
    if (!this.totalAnswerCount) return '--';

    return `${this.quizScore}% [${this.correctAnswerCount}/${this.totalAnswerCount}]`;
  }
}

export default EmployeeTrainingStatusSummary;
